import { List } from "antd";
import React from "react";
import HighLightItem from "./highlightItem";
import "./style.scss";

const HighlightsList = (props: any) => {
  const { highlights } = props;
  return (
    // <div >
    <List
      className="kd-highlight-list-wrapper"
      grid={{ column: 2 }}
      dataSource={highlights}
      renderItem={(item: any) => (
        // <List.Item key={item._id}>
        <HighLightItem key={item._id} highlight={item} />
        // </List.Item>
      )}></List>
    // </div>
  );
};

export default HighlightsList;
